import { CarIcon, HomeIcon } from "@zfp-akademie-a-s/zfp-design/icons";
import { ChildIcon, FinancialSuccessIcon, PiggyBankIcon, TargetIcon } from "Components/_Shared/Icons/Icons";
import { GoalOverviewType } from "Infrastructure/ApiZfp/Schema";

type Props = {
  type: GoalOverviewType;
};

const getIcon = (type: GoalOverviewType) => {
  switch (type) {
    case GoalOverviewType.pension: {
      return <FinancialSuccessIcon />;
    }
    case GoalOverviewType.financial_reserve: {
      return <PiggyBankIcon />;
    }
    case GoalOverviewType.housing: {
      return <HomeIcon />;
    }
    case GoalOverviewType.vehicle: {
      return <CarIcon />;
    }
    case GoalOverviewType.children: {
      return <ChildIcon />;
    }
    case GoalOverviewType.other: {
      return <TargetIcon />;
    }
    default: {
      return <TargetIcon />;
    }
  }
};

export const GoalIcon = ({ type }: Props) => {
  return getIcon(type);
};
